import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../utils/supabaseClient";

// Returns true while the check is running. Sends visitors who are not
// logged-in admins to /login or the home page.
// This is for navigation only: your database policies are what actually protect the data.
export default function useRequireAdmin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (cancelled) return;
      if (!user) {
        navigate("/login");
        return;
      }

      const { data: profile, error } = await supabase
        .from("profiles")
        .select("is_admin")
        .eq("id", user.id)
        .single();

      if (cancelled) return;
      if (error || !profile?.is_admin) {
        navigate("/");
        return;
      }

      setChecking(false);
    }

    check();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return checking;
}